module.exports = __webpack_public_path__ + "static/img/logo_01.888268b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_01.png
// module id = WWJl
// module chunks = 1